import { render } from "./PartnerComponent.vue?vue&type=template&id=fee8c8e4&scoped=true"
import script from "./PartnerComponent.vue?vue&type=script&lang=js"
export * from "./PartnerComponent.vue?vue&type=script&lang=js"

import "./PartnerComponent.vue?vue&type=style&index=0&id=fee8c8e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee8c8e4"]])

export default __exports__